module.exports = __webpack_public_path__ + "static/img/process-thumb.5525228.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/default/process-thumb.png
// module id = 81zr
// module chunks = 2